import { render, staticRenderFns } from "./ListComment.vue?vue&type=template&id=27848ed6&scoped=true&"
import script from "./ListComment.vue?vue&type=script&lang=js&"
export * from "./ListComment.vue?vue&type=script&lang=js&"
import style0 from "./ListComment.vue?vue&type=style&index=0&id=27848ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27848ed6",
  null
  
)

export default component.exports